import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Footer } from './Footer';
import { FloatingChat } from '../FloatingChat';
import { isPainelOficinaRoute } from '@/lib/painelOficina';

export const DashboardLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState<boolean>(Boolean(document.fullscreenElement));
  const location = useLocation();
  
  // Verificar se estamos na página do Kanban para aplicar layout especial
  const isKanbanPage = location.pathname === '/kanban';
  const isOficinaPage = isPainelOficinaRoute(location.pathname);
  const useFullBleedLayout = isKanbanPage || isOficinaPage;
  const isOficinaPresentationMode = isOficinaPage && isFullscreen;

  React.useEffect(() => {
    const onFs = () => setIsFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener('fullscreenchange', onFs);
    return () => document.removeEventListener('fullscreenchange', onFs);
  }, []);

  return (
    <div className="h-screen bg-background">
      {!isOficinaPresentationMode && (
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={() => setSidebarOpen(false)}
          isCollapsed={sidebarCollapsed}
        />
      )}
      
      <div
        className={`transition-all duration-300 flex flex-col ${
          useFullBleedLayout
            ? 'h-screen max-h-screen min-h-0 overflow-hidden'
            : 'min-h-screen'
        } ${isOficinaPresentationMode ? '' : sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-64'}`}
      >
        {!isOficinaPresentationMode && (
          <Header 
            onMenuClick={() => setSidebarOpen(true)}
            onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
            sidebarCollapsed={sidebarCollapsed}
          />
        )}

        <main className={useFullBleedLayout ? 'h-full min-h-0 flex-1 overflow-hidden' : 'py-8 flex-1 md:py-10'}>
          <div
            className={
              useFullBleedLayout
                ? 'flex h-full min-h-0 max-h-full flex-col'
                : 'mx-auto w-full max-w-[1600px] pl-6 pr-6 sm:pl-8 sm:pr-10 lg:pl-10 lg:pr-14 xl:pl-12 xl:pr-20'
            }
          >
            <Outlet />
          </div>
        </main>

        {!useFullBleedLayout && !isOficinaPresentationMode && <Footer />}
      </div>
      
      {/* Chat flutuante disponível em todas as telas */}
      <FloatingChat />
    </div>
  );
};
